import { react2angular } from 'react2angular';
import StateName from './index';

export const StateNameModule = angular
  .module('app.components.stateName', [])
  .component('stateName', react2angular(StateName))
  .name;



// WEBPACK FOOTER //
// ./src/app/admin/components/StateName/index.ng.js